import styled from 'styled-components';

export const PageTitle = styled.h3`
  font-size: ${({ theme }) => theme.fs.lg};
  font-weight: 500;
  line-height: ${({ theme }) => theme.spacing.x7};
  color: ${({ theme }) => theme.palette.primary};
  text-align: center;
  margin: ${({ theme }) => `${theme.spacing.x3} 0`};
  > b {
    display: block;
    font-weight: 800;
  }
`;

export const NotFoundText = styled.p`
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.darkGray};
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.x3} 0`};
`;

export const Btn = styled.button`
  margin: ${({ theme }) => `${theme.spacing.x3} auto`};
`;

export const Card = styled.div`
  border-radius: ${({ theme }) => theme.rounded.x3};
  background-color: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => `${theme.spacing.x6} ${theme.spacing.x3}`};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
`;

export const DateRowWrapper = styled.div``;

export const FlightCardList = styled.div``;

export const FlightCard = styled.div`
  + * {
    margin-top: ${({ theme }) => theme.spacing.x2};
  }
`;
